import {
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { FormPopupComponent } from '../../../../components';
import { SupplierFormComponent } from '../supplier-form/supplier-form.component';
import {SupplierDto, SuppliersClient, UpdateSupplierCommand } from '@services';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'edit-supplier-form',
    imports: [FormPopupComponent, SupplierFormComponent],
    templateUrl: './edit-supplier-form.component.html',
})
export class EditSupplierFormComponent {
    @ViewChild(SupplierFormComponent, { static: false }) editNewForm: SupplierFormComponent;

    @Input() isReadOnly: boolean = false;
    @Input() supplierId: string;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onSave = new EventEmitter();

    private suppliersClient = inject(SuppliersClient);

    formData: SupplierDto = {} as SupplierDto;

    loadSupplierById = (id: any) => {
        this.suppliersClient.getSupplier(id).subscribe({
            next: (data: SupplierDto) => {
                this.formData = data;
            },
            error: () => {},
        });
    };

    onPopupSaveClick = () => {
        let formData = this.editNewForm.getData();

        let createCommand = new UpdateSupplierCommand({
            id: this.supplierId,
            number: formData.number,
            status: formData.status,
            name: formData.name,
            group: formData.group,
            plant: formData.plant,
            sac: formData.sac,
            address: formData.address,
            phone: formData.phone,
            email: formData.email,
        });

        this.suppliersClient.updateSupplier(createCommand).subscribe({
            next: async () => {
                this.visible = false;
                this.visibleChange.emit(this.visible);
                this.onSave.emit();
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg) => {
                    notify(
                        {
                            message: errMsg.message,
                            type: 'error',
                            displayTime: 5000,
                        },
                        {
                            position: 'bottom right',
                            direction: 'up-push',
                        },
                    );
                });
            },
        });
    };

    onVisibleChange(visible: boolean) {
        this.visibleChange.emit(visible);
    }

    protected onOpen() {
        this.loadSupplierById(this.supplierId);
    }
}
